import React from 'react'
import PropTypes from 'prop-types'
import AddToCartButton from './AddToCartButton'

export default function RecommendationActions({ product }) {
  if (product.category === 'virtual_visit') {
    if (!product.sku) return null
    return (
      <a href={`/virtual_visits/new?sku=${encodeURIComponent(product.sku)}`} className="btn btn-primary">
        Check Availability
      </a>
    )
  }

  return (
    <>
      <AddToCartButton product={product} />
      {product.is_subscribable && (
        <AddToCartButton product={product} className="btn btn-outline-primary" subscription>
          Subscribe
        </AddToCartButton>
      )}
    </>
  )
}

RecommendationActions.propTypes = {
  product: PropTypes.shape({
    category: PropTypes.string,
    sku: PropTypes.string,
    is_subscribable: PropTypes.bool.isRequired,
  }).isRequired,
}
